const FormFormatResources = {

    rooms_form_format:[
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Floor Type:',
            model_name: 'floor_id',
            ref:        'floor_id_input',
            ref_alt:    'floor_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Closed?:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Door Number:',
            model_name: 'door_number',
            ref:        'door_number_input',
            ref_alt:    'door_number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Fixtures/Beds:',
            model_name: 'fixtures',
            ref:        'fixtures_input',
            ref_alt:    'fixtures_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'fixture_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'SQ/FT:',
            model_name: 'sq_ft',
            ref:        'sq_ft_input',
            ref_alt:    'sq_ft_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'sq_ft_simbol'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Essential cleaning:',
            model_name: 'essential_cleaning',
            ref:        'essential_cleaning_input',
            ref_alt:    'essential_cleaning_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Work Group:',
            model_name: 'work_group',
            ref:        'work_group_input',
            ref_alt:    'work_group_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Excl. Dailys:',
            model_name: 'exclude_daily',
            ref:        'exclude_daily_input',
            ref_alt:    'exclude_daily_input_alt',
            required:   false,
            option_type: 'excl_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Excl. Projects:',
            model_name: 'exclude_project',
            ref:        'exclude_project_input',
            ref_alt:    'exclude_project_input_alt',
            required:   false,
            option_type: 'excl_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Patient room:',
            model_name: 'patient',
            ref:        'patient_input',
            ref_alt:    'patient_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Comment:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Disable Daily Updates:',
            model_name: 'disabled_daily',
            ref:        'disabled_daily_input',
            ref_alt:    'disabled_daily_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Disable Project Updates:',
            model_name: 'disabled_project',
            ref:        'disabled_project_input',
            ref_alt:    'disabled_project_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
        },
        {
            class:  'col-auto',
            type:       'checkbox',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Daily shift:',
            model_name: '',
            ref:        'daily_shift_input',
            ref_alt:    'daily_shift_input_alt',
            required:   false,
            checkboxes:[
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'shift1',
                    ref:        'shift1_input',
                    ref_alt:    'shift1_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'shift2',
                    ref:        'shift2_input',
                    ref_alt:    'shift2_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'shift3',
                    ref:        'shift3_input',
                    ref_alt:    'shift3_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       'none',
                    model_name: 'none',
                    ref:        'none_input',
                    ref_alt:    'none_input_alt',
                }
                
            ]
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'SinkMin:',
            model_name: 'time_adjustment',
            ref:        'time_adjustment_input',
            ref_alt:    'time_adjustment_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'time_adjustment_simbol'
        },
        {
            class:  'col-auto',
            type:       'radio',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Task Types:',
            model_name: 'radio',
            ref:        'radio_input',
            ref_alt:    'radio_input_alt',
            required:   false,
            radios:[
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Daily',
                    ref:        'daily_input',
                    ref_alt:    'daily_input_alt',
                    value:      'daily',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Projects',
                    ref:        'projects_input',
                    ref_alt:    'projects_input_alt',
                    value:      'projects',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Policing',
                    ref:        'policing_input',
                    ref_alt:    'policing_input_alt',
                    value:      'policing',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'None',
                    ref:        'all_input',
                    ref_alt:    'all_input_alt',
                    value:      'all',
                }
                
            ]
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency_id',
            ref:        'frequency_id_input',
            ref_alt:    'frequency_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency',
            ref:        'frequency_input',
            ref_alt:    'frequency_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'freq_simbol'
        },
    ],

    room_tasks_form_format:[
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Floor Type:',
            model_name: 'floor_id',
            ref:        'floor_id_input',
            ref_alt:    'floor_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Closed?:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Door Number:',
            model_name: 'door_number',
            ref:        'door_number_input',
            ref_alt:    'door_number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Fixtures/Beds:',
            model_name: 'fixtures',
            ref:        'fixtures_input',
            ref_alt:    'fixtures_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'fixture_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'SQ/FT:',
            model_name: 'sq_ft',
            ref:        'sq_ft_input',
            ref_alt:    'sq_ft_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'sq_ft_simbol'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Essential cleaning:',
            model_name: 'essential_cleaning',
            ref:        'essential_cleaning_input',
            ref_alt:    'essential_cleaning_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Work Group:',
            model_name: 'work_group',
            ref:        'work_group_input',
            ref_alt:    'work_group_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Excl. Dailys:',
            model_name: 'exclude_daily',
            ref:        'exclude_daily_input',
            ref_alt:    'exclude_daily_input_alt',
            required:   false,
            option_type: 'excl_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Excl. Projects:',
            model_name: 'exclude_project',
            ref:        'exclude_project_input',
            ref_alt:    'exclude_project_input_alt',
            required:   false,
            option_type: 'excl_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Patient room:',
            model_name: 'patient',
            ref:        'patient_input',
            ref_alt:    'patient_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Comment:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Disable Daily Updates:',
            model_name: 'disabled_daily',
            ref:        'disabled_daily_input',
            ref_alt:    'disabled_daily_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Disable Project Updates:',
            model_name: 'disabled_project',
            ref:        'disabled_project_input',
            ref_alt:    'disabled_project_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-auto',
            type:       'checkbox',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Daily shift:',
            model_name: '',
            ref:        'daily_shift_input',
            ref_alt:    'daily_shift_input_alt',
            required:   false,
            checkboxes:[
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'shift1',
                    ref:        'shift1_input',
                    ref_alt:    'shift1_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'shift2',
                    ref:        'shift2_input',
                    ref_alt:    'shift2_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'shift3',
                    ref:        'shift3_input',
                    ref_alt:    'shift3_input_alt',
                },
                {
                    class:      '',
                    disabled:   false,
                    step:       '',
                    name:       'none',
                    model_name: 'none',
                    ref:        'none_input',
                    ref_alt:    'none_input_alt',
                }
                
            ]
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'SinkMin:',
            model_name: 'time_adjustment',
            ref:        'time_adjustment_input',
            ref_alt:    'time_adjustment_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'time_adjustment_simbol'
        },
        {
            class:  'col-auto',
            type:       'radio',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Task Types:',
            model_name: 'radio',
            ref:        'radio_input',
            ref_alt:    'radio_input_alt',
            required:   false,
            radios:[
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Daily',
                    ref:        'daily_input',
                    ref_alt:    'daily_input_alt',
                    value:      'daily',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Projects',
                    ref:        'projects_input',
                    ref_alt:    'projects_input_alt',
                    value:      'projects',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'Policing',
                    ref:        'policing_input',
                    ref_alt:    'policing_input_alt',
                    value:      'policing',
                },
                {
                    div_class:  'p-0 form-check custom-radio',
                    class:      'custom-control-input',
                    disabled:   false,
                    step:       '',
                    name:       'None',
                    ref:        'all_input',
                    ref_alt:    'all_input_alt',
                    value:      'all',
                }
                
            ]
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency_id',
            ref:        'frequency_id_input',
            ref_alt:    'frequency_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency',
            ref:        'frequency_input',
            ref_alt:    'frequency_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'freq_simbol'
        },
    ],


    buildings_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Level Counter:',
            model_name: 'level_counter',
            ref:        'level_counter_input',
            ref_alt:    'level_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'level_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Area Counter:',
            model_name: 'area_counter',
            ref:        'area_counter_input',
            ref_alt:    'area_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'area_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Counter:',
            model_name: 'room_counter',
            ref:        'room_counter_input',
            ref_alt:    'room_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'room_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_footage',
            ref:        'sq_footage_input',
            ref_alt:    'sq_footage_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'sq_footage_simbol'
        },
    ],

    levels_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Area Counter:',
            model_name: 'area_counter',
            ref:        'area_counter_input',
            ref_alt:    'area_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'area_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Counter:',
            model_name: 'room_counter',
            ref:        'room_counter_input',
            ref_alt:    'room_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'room_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_footage',
            ref:        'sq_footage_input',
            ref_alt:    'sq_footage_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'sq_footage_simbol'
        },
    ],

    areas_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
            exclude: true,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Counter:',
            model_name: 'room_counter',
            ref:        'room_counter_input',
            ref_alt:    'room_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'room_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_footage',
            ref:        'sq_footage_input',
            ref_alt:    'sq_footage_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'sq_footage_simbol'
        },
    ],

    cost_centers_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center #:',
            model_name: 'cost_center',
            ref:        'cost_center_input',
            ref_alt:    'cost_center_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Director's First Name:",
            model_name: 'director_first_name',
            ref:        'director_first_name_input',
            ref_alt:    'director_first_name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Director's Last Name",
            model_name: 'director_last_name',
            ref:        'director_last_name_input',
            ref_alt:    'director_last_name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Director's Ext",
            model_name: 'director_ext',
            ref:        'director_ext_input',
            ref_alt:    'director_ext_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Counter:',
            model_name: 'room_counter',
            ref:        'room_counter_input',
            ref_alt:    'room_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'room_counter_simbol'
        },
    ],

    cost_center_departments_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Cost Center:",
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Associate's Counter:",
            model_name: 'associate_counter',
            ref:        'associate_counter_input',
            ref_alt:    'associate_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'associate_counter_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Personnel Counter:',
            model_name: 'personnel_counter',
            ref:        'personnel_counter_input',
            ref_alt:    'personnel_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'personnel_counter_simbol'
        },
    ],

    cost_center_personnel_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'First Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Last Name:',
            model_name: 'last_name',
            ref:        'last_name_input',
            ref_alt:    'last_name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   false,
            exclude: true,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cost Center Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Ext:',
            model_name: 'ext',
            ref:        'ext_input',
            ref_alt:    'ext_input_alt',
            required:   false,
        },
        
    ],

    room_types_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Floor:",
            model_name: 'floor_id',
            ref:        'floor_id_input',
            ref_alt:    'floor_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Housekeper II:",
            model_name: 'housekeeper',
            ref:        'housekeeper_input',
            ref_alt:    'housekeeper_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Patient:",
            model_name: 'patient',
            ref:        'patient_input',
            ref_alt:    'patient_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Unit:',
            model_name: 'unit',
            ref:        'unit_input',
            ref_alt:    'unit_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'unit_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Room Counter:",
            model_name: 'room_counter',
            ref:        'room_counter_input',
            ref_alt:    'room_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'room_counter_simbol'
        },
    ],

    associates_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'full_name',
            ref:        'full_name_input',
            ref_alt:    'full_name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Phone 1:',
            model_name: 'phone1',
            ref:        'phone1_input',
            ref_alt:    'phone1_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Phone 2:',
            model_name: 'phone2',
            ref:        'phone2_input',
            ref_alt:    'phone2_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Country:",
            model_name: 'country_id',
            ref:        'country_id_input',
            ref_alt:    'country_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'State:',
            model_name: 'state',
            ref:        'state_input',
            ref_alt:    'state_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'City:',
            model_name: 'city',
            ref:        'city_input',
            ref_alt:    'city_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Zip Code:',
            model_name: 'zip_code',
            ref:        'zip_code_input',
            ref_alt:    'zip_code_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Address 1:',
            model_name: 'address1',
            ref:        'address1_input',
            ref_alt:    'address1_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Address 2:',
            model_name: 'address2',
            ref:        'address2_input',
            ref_alt:    'address2_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Role:",
            model_name: 'role_id',
            ref:        'role_id_input',
            ref_alt:    'role_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Reports to:",
            model_name: 'reports_to',
            ref:        'reports_to_input',
            ref_alt:    'reports_to_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Permissions Template:",
            model_name: 'permissions_template_id',
            ref:        'permissions_template_id_input',
            ref_alt:    'permissions_template_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Status:",
            model_name: 'status_id',
            ref:        'status_id_input',
            ref_alt:    'status_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Contact Type:",
            model_name: 'contact_type_id',
            ref:        'contact_type_id_input',
            ref_alt:    'contact_type_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Cost Center Department:",
            model_name: 'department_id',
            ref:        'department_id_input',
            ref_alt:    'department_id_input_alt',
            required:   false,
        },
        
    ],

    positions_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Group:",
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Start Salary:',
            model_name: 'start_salary',
            ref:        'start_salary_input',
            ref_alt:    'start_salary_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'start_salary_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "End Salary:",
            model_name: 'end_salary',
            ref:        'end_salary_input',
            ref_alt:    'end_salary_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'end_salary_simbol'
        },
    ],

    contact_types_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Include Days Off:",
            model_name: 'include_days_off',
            ref:        'include_days_off_input',
            ref_alt:    'include_days_off_input_alt',
            required:   false,
            option_type: 'boolean_options',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Include Assignment:",
            model_name: 'include_assignment',
            ref:        'include_assignment_input',
            ref_alt:    'include_assignment_input_alt',
            required:   false,
            option_type: 'boolean_options',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Include Census:",
            model_name: 'include_census',
            ref:        'include_census_input',
            ref_alt:    'include_census_input_alt',
            required:   false,
            option_type: 'boolean_options',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Include QC:",
            model_name: 'include_qc',
            ref:        'include_qc_input',
            ref_alt:    'include_qc_input_alt',
            required:   false,
            option_type: 'boolean_options',
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate Counter:',
            model_name: 'associate_counter',
            ref:        'associate_counter_input',
            ref_alt:    'associate_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'associate_counter_simbol'
        },
    ],

    daily_assignments_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Assignment #:',
            model_name: 'assignment_number',
            ref:        'assignment_number_input',
            ref_alt:    'assignment_number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Days/Week:',
            model_name: 'days_per_week',
            ref:        'days_per_week_input',
            ref_alt:    'days_per_week_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'days_per_week_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Minutes/Discharge:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Avg. Time:',
            model_name: 'avg_time',
            ref:        'avg_time_input',
            ref_alt:    'avg_time_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'avg_time_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Total Time:',
            model_name: 'total_minutes',
            ref:        'total_minutes_input',
            ref_alt:    'total_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Avalaible Minutes',
            model_name: 'total_shift_work_time',
            ref:        'total_shift_work_time_input',
            ref_alt:    'total_shift_work_time_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_shift_work_time_simbol'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Census:",
            model_name: 'census',
            ref:        'census_input',
            ref_alt:    'census_input_alt',
            required:   false,
            option_type: 'boolean_options',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Shift:",
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Group:",
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Cost Center Department:",
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Associate:",
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            label:      'associate_name',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate Pager:',
            model_name: 'associate_pager',
            ref:        'associate_pager_input',
            ref_alt:    'associate_pager_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Supervisor:",
            model_name: 'supervisor_associate_id',
            ref:        'supervisor_associate_id_input',
            ref_alt:    'supervisor_associate_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor Pager:',
            model_name: 'supervisor_pager',
            ref:        'supervisor_pager_input',
            ref_alt:    'supervisor_pager_input_alt',
            required:   false,
        },
    ],

    shifts_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Number #:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Class:",
            model_name: 'class_id',
            ref:        'class_id_input',
            ref_alt:    'class_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Prep Minutes:',
            model_name: 'prep_minutes',
            ref:        'prep_minutes_input',
            ref_alt:    'prep_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'prep_minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Cleanup Minutes:",
            model_name: 'clenaup_minutes',
            ref:        'clenaup_minutes_input',
            ref_alt:    'clenaup_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'clenaup_minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Total Minutes:",
            model_name: 'total_minutes',
            ref:        'total_minutes_input',
            ref_alt:    'total_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Work Time:",
            model_name: 'work_time',
            ref:        'work_time_input',
            ref_alt:    'work_time_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'work_time_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Break Counter:",
            model_name: 'break_counter',
            ref:        'break_counter_input',
            ref_alt:    'break_counter_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'break_counter_simbol'
        },
    ],

    breaks_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Number #:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Shift:",
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Length:',
            model_name: 'length',
            ref:        'length_input',
            ref_alt:    'length_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'length_simbol'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Paid:',
            model_name: 'paid',
            ref:        'paid_input',
            ref_alt:    'paid_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
    ],

    tasks_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Cleaning Code:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Task Type:",
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Production Standard:',
            model_name: 'production_standard',
            ref:        'production_standard_input',
            ref_alt:    'production_standard_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'production_standard_simbol'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Unit:',
            model_name: 'unit',
            ref:        'unit_input',
            ref_alt:    'unit_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
    ],

    projects_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Number:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Associate:",
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label: 'associate_name',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Show Minutes:",
            model_name: 'show_minutes',
            ref:        'show_minutes_input',
            ref_alt:    'show_minutes_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Total Minutes:',
            model_name: 'total_minutes',
            ref:        'total_minutes_input',
            ref_alt:    'total_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_minutes_simbol'
        },
    ],

    service_requests_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Requestor Name:',
            model_name: 'requestor_name',
            ref:        'requestor_name_input',
            ref_alt:    'requestor_name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Requestor Email:',
            model_name: 'requestor_email',
            ref:        'requestor_email_input',
            ref_alt:    'requestor_email_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Requestor Phone:',
            model_name: 'requestor_phone',
            ref:        'requestor_phone_input',
            ref_alt:    'requestor_phone_input_alt',
            required:   false,
        },
    ],

    staffing_scenarios_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Scenario:',
            model_name: 'scenario',
            ref:        'scenario_input',
            ref_alt:    'scenario_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'FTE Hours:',
            model_name: 'fte_hours',
            ref:        'fte_hours_input',
            ref_alt:    'fte_hours_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'fte_hours_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Budgeted FTEs:',
            model_name: 'budgeted_ftes',
            ref:        'budgeted_ftes_input',
            ref_alt:    'budgeted_ftes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'budgeted_ftes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Benefits:',
            model_name: 'benefits',
            ref:        'benefits_input',
            ref_alt:    'benefits_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'benefits_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Nonproductive:',
            model_name: 'nonproductive',
            ref:        'nonproductive_input',
            ref_alt:    'nonproductive_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'nonproductive_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Paid Break Minutes:',
            model_name: 'paid_break_minutes',
            ref:        'paid_break_minutes_input',
            ref_alt:    'paid_break_minutes_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'paid_break_minutes_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Management Team:',
            model_name: 'management_team',
            ref:        'management_team_input',
            ref_alt:    'management_team_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'management_team_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Average Wage:',
            model_name: 'average_wage',
            ref:        'average_wage_input',
            ref_alt:    'average_wage_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'average_wage_simbol'
        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Total Salary Compensation:',
            model_name: 'total_salary_compensation',
            ref:        'total_salary_compensation_input',
            ref_alt:    'total_salary_compensation_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_salary_compensation_simbol'
        },
    ],

    beds_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room:',
            model_name: 'room',
            ref:        'room_input',
            ref_alt:    'room_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Bed:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
    ],

    log_productivities_form_format: [
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Daily Assignment:",
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Associate:",
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label: 'associate_name',
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Include In Productivity:",
            model_name: 'include_productivity',
            ref:        'include_productivity_input',
            ref_alt:    'include_productivity_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
    ],

    rotation_templates_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Day Rotations:",
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-3',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Day of week rotation begins:",
            model_name: 'days_id',
            ref:        'days_id_input',
            ref_alt:    'days_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       "Shift:",
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Template Counter:',
            model_name: 'total_templates',
            ref:        'total_templates_input',
            ref_alt:    'total_templates_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_templates_simbol'
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Schedule Counter:',
            model_name: 'total_schedules',
            ref:        'total_schedules_input',
            ref_alt:    'total_schedules_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_schedules_simbol'
        },
    ],

    inspection_templates_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Instruction:',
            model_name: 'instruction',
            ref:        'instruction_input',
            ref_alt:    'instruction_input_alt',
            required:   false,
        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Inspection Items Counter:',
            model_name: 'total_items',
            ref:        'total_items_input',
            ref_alt:    'total_items_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_items_simbol'
        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Type Counter:',
            model_name: 'total_room_types',
            ref:        'total_room_types_input',
            ref_alt:    'total_room_types_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_room_types_simbol'
        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Template Inspection Counter:',
            model_name: 'total_template_inspections',
            ref:        'total_template_inspections_input',
            ref_alt:    'total_template_inspections_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_template_inspections_simbol'
        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Instant Inspection Counter:',
            model_name: 'total_instant_inspections',
            ref:        'total_instant_inspections_input',
            ref_alt:    'total_instant_inspections_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_instant_inspections_simbol'
        },
    ],

    template_inspections_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Completed:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Manager Comment:',
            model_name: 'manager_comment',
            ref:        'manager_comment_input',
            ref_alt:    'manager_comment_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Inspection Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label: 'associate_name'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_employee_id',
            ref:        'associate_employee_id_input',
            ref_alt:    'associate_employee_id_input_alt',
            required:   false,
            label: 'associate_name'

        },
        {
            class:  'col-md-3',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Counter:',
            model_name: 'total_rooms',
            ref:        'total_rooms_input',
            ref_alt:    'total_rooms_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_rooms_simbol'
        },
    ],

    instant_inspections_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Completed:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
            option_type: 'boolean_options'
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Manager Comment:',
            model_name: 'manager_comment',
            ref:        'manager_comment_input',
            ref_alt:    'manager_comment_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Inspection Template:',
            model_name: 'inspection_template_id',
            ref:        'inspection_template_id_input',
            ref_alt:    'inspection_template_id_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label: 'associate_name'
        },
        {
            class:  'col-md-2',
            type:       'select',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_employee_id',
            ref:        'associate_employee_id_input',
            ref_alt:    'associate_employee_id_input_alt',
            required:   false,
            label: 'associate_name'

        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room:',
            model_name: 'room',
            ref:        'room_input',
            ref_alt:    'room_input_alt',
            required:   false,
        },
    ],

    inspection_items_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associated Room Types:',
            model_name: 'total_room_types',
            ref:        'total_room_types_input',
            ref_alt:    'total_room_types_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_room_types_simbol'
        },
    ],

    surveys_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Note:',
            model_name: 'note',
            ref:        'note_input',
            ref_alt:    'note_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Subject:',
            model_name: 'subject',
            ref:        'subject_input',
            ref_alt:    'subject_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Email Body:',
            model_name: 'email_body',
            ref:        'email_body_input',
            ref_alt:    'email_body_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Question Counter:',
            model_name: 'total_questions',
            ref:        'total_questions_input',
            ref_alt:    'total_questions_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_questions_simbol'
        },
    ],

    step_codes_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Code:',
            model_name: 'code',
            ref:        'code_input',
            ref_alt:    'code_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Memo:',
            model_name: 'memo',
            ref:        'memo_input',
            ref_alt:    'memo_input_alt',
            required:   false,
        },
    ],

    vacant_beds_adjustment_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Room Usage:',
            model_name: 'room_usage',
            ref:        'room_usage_input',
            ref_alt:    'room_usage_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Vacant Bed Adjustment:',
            model_name: 'vacant_bed',
            ref:        'vacant_bed_input',
            ref_alt:    'vacant_bed_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'vacant_bed_simbol'
        },
    ],

    floor_types_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   false,
        },
        {
            class:  'col-md-2',
            type:       'double-input',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Associated Tasks:',
            model_name: 'total_tasks',
            ref:        'total_tasks_input',
            ref_alt:    'total_tasks_input_alt',
            required:   false,
            simbol_text: '',
            symbol_model_name: 'total_tasks_simbol'
        },
    ],

    time_off_form_format: [
        {
            class:  'col-md-2',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
    ],

}

export default FormFormatResources